export function featureDetect(): boolean {
  if (typeof globalThis === 'undefined') return false;
  const nav = (globalThis as { navigator?: unknown }).navigator;
  if (!nav || typeof nav !== 'object') return false;
  return 'modelContext' in nav && typeof (nav as { modelContext?: unknown }).modelContext === 'object';
}
